module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCookieBanner),
      expression: "showCookieBanner"
    }],
    staticClass: "cookie-banner"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "cookie-banner-dismiss",
    on: {
      "click": _vm.hideCookieBanner
    }
  }, [_c('span', {
    staticClass: "dismiss-text"
  }, [_vm._v("dismiss")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-close"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cookie-banner-message"
  }, [_vm._v("MikMak uses cookies to enhance your experience on our site. By browsing our site, you agree to our "), _c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("privacy policy")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6144b7d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/CookieBanner.vue
// module id = 486
// module chunks = 0